var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.62 4.656V2H8.734v2.656H3v1.433h1.716L5.938 22h12.526l1.222-15.91h1.95V4.655H15.62zM14.21 3.41v1.222h-4.042V3.41h4.042zM7.23 20.543L6.126 6.066h12.103l-1.128 14.477h-9.87z",
    fill: "#FB4E4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.894 8.134h-1.433v10.411h1.433V8.134zM14.095 18.511l1.432.078.565-10.42-1.431-.077-.566 10.42zM8.26 8.17l.565 10.419 1.432-.078-.565-10.419-1.431.078z",
    fill: "#FB4E4E"
  })));
}

export default SvgTrash;